module.exports = __webpack_public_path__ + "static/media/point leave.eff201c7.svg";